import MarkHomeworkCourseView from './component';
import _routes from './routes';

export const routes = _routes;
export default MarkHomeworkCourseView;



// WEBPACK FOOTER //
// ./containers/Group/Homework/PaperBased/MarkHomeworkCourseView/index.js